import React from 'react';
import { connect } from 'react-redux';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';
import TariffList from '~/src/components/Bundles/TariffList';
import Content from '~/src/components/Bundles/Content';
import { Wrapper, Quiz, BannerSection, BundlesTitle, HeadContainer, TariffMenu } from './styled';

const Banner = dynamic(() => import('~/src/components/Banners/Banner'));

class Bundles extends React.Component {
    static propTypes = {
        tariffs: PropTypes.array,
        banner: PropTypes.object,
        title: PropTypes.string,
    };

    onBannerClick = ({ clickType }) => {
        dataLayerPush({
            'event': 'UAevent',
            'category': 'banner',
            'action': `click banner to ${clickType === 'clickOnBanner' ? 'req full' : 'req'}`,
            'label': window.location.pathname,
        });

        window.location.href = this.props.banner.link;
    }

    render() {
        const { isAuth, tariffs, city, title, pageContent, questions, banner, isVillage } = this.props;

        const tabFlat = 'Для квартиры';
        const tabVillage = 'Для частного дома';

        const menuItems = [
            { route: '/bundles', text: tabFlat },
            { route: '/bundles/village', text: tabVillage }
        ];
        const activeMenuItem = isVillage ? 1 : 0;

        const apartmentTariffs = tariffs.filter(item => item.salePackage2in1.is_cottage === 0);
        const cottageTariffs = tariffs.filter(item => item.salePackage2in1.is_cottage > 0);
        const hasVillageTariffs = !!((apartmentTariffs.length && cottageTariffs.length));

        const filteredTariffs = !hasVillageTariffs
            ? tariffs
            : isVillage ? cottageTariffs : apartmentTariffs;
        let newTitle = title;

        if (city.domain === 'interzet') {
            newTitle = `Выберите интернет и цифровое ТВ в ${city.cityIn}`;
        }

        if (city.domain === 'interzet' && isVillage) {
            newTitle = `Телевидение и интернет в частный дом в ${city.cityIn}`;
        }

        return (
            <Wrapper isAuth={isAuth}>
                <HeadContainer>
                    <BundlesTitle id='bundles_title'>
                        {newTitle}
                    </BundlesTitle>
                    {
                        hasVillageTariffs &&
                        <TariffMenu items={menuItems} activeItem={activeMenuItem}/>
                    }
                </HeadContainer>
                <TariffList
                    tariffs={filteredTariffs}
                    ref={tariffList => this.tariffList = tariffList}
                />
                <GridContainer>
                    {
                        !isVillage && questions && questions.length > 0 &&
                        <Quiz alias='bundles' openChannelsPopUp={this.openChannelsPopUp}/>
                    }
                    {
                        banner &&
                        <BannerSection>
                            <Banner
                                onClickHandler={this.onBannerClick}
                                banner={banner}
                            />
                        </BannerSection>
                    }
                    <Content isVillage={isVillage} city={city.cityIn} pageContent={pageContent}/>
                </GridContainer>
            </Wrapper>
        );
    }

    openChannelsPopUp = tariff => {
        if (this.tariffList) {
            return this.tariffList.wrappedInstance.onClickChannels(tariff);
        }
    };
}

const mapStateToProps = (state) => ({
    city: state.city.currentCity,
    cityDomain: state.city.currentCity.domain,
    isAuth: state.auth.isAuth,
    questions: state.quiz.questions,
    banner: state.bundles.banner,
});

export default connect(mapStateToProps)(Bundles);
